import { func, object } from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { StrapiImg } from 'components';
import { appService } from 'services';

import defaultArrivajImg from 'assets/img/default-arrivaj-img.png';
import defaultTouloisirsImg from 'assets/img/default-touloisirs-img.png';

const GiftcardPromote = ({ promote, goToProductSow }) => {
  const { t } = useTranslation();

  const giftcardPicture = useMemo(() => {
    if (!promote?.picture) {
      return {
        frontUrl: appService.isTouloisirs() ? defaultTouloisirsImg : defaultArrivajImg
      };
    }

    return promote.picture;
  }, [promote]);

  return (
    <div className="flex flex-col h-full border border-gray-300 rounded-lg shadow-lg overflow-hidden">
      <button type="button" className="opacity-0 absolute inset-0" onClick={goToProductSow}>
        {t('products:productShowCta', { title: promote?.title || '' })}
      </button>

      <div className="aspect-video overflow-hidden shrink-0 max-h-48">
        <StrapiImg image={giftcardPicture} />
      </div>

      <div className="border-t border-gray-300 p-4">
        <h3 className="h3 truncate-line one-line mb-3">{promote.title}</h3>
        <hr className="w-10 bg-yellow-500 h-[0.13rem]" />
        <p className="pt-3 text-sm">{promote?.category?.name}</p>
      </div>
    </div>
  );
};

GiftcardPromote.propTypes = {
  promote: object.isRequired,
  goToProductSow: func.isRequired
};

export default GiftcardPromote;
